/** @jsxImportSource @emotion/react */

import {css} from "@emotion/react";
import Button from "components/Button";
import {usePermissions} from "hooks/auth";
import {Permissions} from "api/auth";

function NotTakenContent({
  unsubmittingQuote,
  onUnSubmitQuote,
}: {
  unsubmittingQuote: boolean;
  onUnSubmitQuote: () => void;
}) {
  const permissions = usePermissions();

  return (
    <>
      {permissions.includes(Permissions.UNSUBMIT_QUOTE_ALWAYS) ? (
        <Button
          size="large"
          isLoading={unsubmittingQuote}
          css={css`
            margin-bottom: 20px;
          `}
          onClick={() => onUnSubmitQuote()}
        >
          Unsubmit Quote
        </Button>
      ) : (
        <></>
      )}

      {/* Main Part */}
      <div
        css={(theme) => css`
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          min-height: 300px;
          width: 600px;
          background: ${theme.color.brand.tertiary};
          border-radius: 8px;
          padding: 40px 32px;
        `}
      >
        <h2
          css={(theme) =>
            css`
              ${theme.text.header1}
              margin-top: 0px;
              text-align: center;
            `
          }
        >
          This quote was not taken.
        </h2>
      </div>
    </>
  );
}

export default NotTakenContent;
